'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Generic = require('./components/Generic.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Generic).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-messages/lib/components/generic/index.js
// module id = 368
// module chunks = 1